import { PagesId } from '@ts-enums/PagesId'
import { Translations } from '@ts-types/Translations'

const globalTranslations: Translations = {
  es: {
    seo_title: 'Política de Reembolso',
    seo_description:
      'Consulta la Política de Reembolso de wicadu para conocer las condiciones y procedimientos aplicables a cancelaciones y reembolsos de suscripciones.',
    seo_keywords:
      'wicadu, política de reembolso, reembolso de suscripción, cancelación de suscripción, términos de reembolso, condiciones de reembolso, política de cancelación, reembolsos en línea',
    breadcrumbs: {
      home: 'Inicio',
      legal: 'Políticas y Cumplimiento',
      refund_policy: 'Política de Reembolso',
    },
    page_id: PagesId.LegalRefundPolicy,
    article: {
      title: 'Política de Reembolso',
      description: 'Por favor, visita la versión en inglés',
    },
  },
  en: {
    seo_title: 'Refund Policy',
    seo_description:
      "Review wicadu's Refund Policy to understand the terms and procedures applicable to subscription cancellations and refunds.",
    seo_keywords:
      'wicadu, refund policy, subscription refund, subscription cancellation, refund terms, refund conditions, cancellation policy, online refunds',
    breadcrumbs: {
      home: 'Home',
      legal: 'Policies and Compliance',
      refund_policy: 'Refund Policy',
    },
    page_id: PagesId.LegalRefundPolicy,
    article: {
      title: 'Refund Policy',
      description: 'Your satisfaction matters to us. We aim to provide a fair and transparent refund process for all customers, please review the following terms',
      who_we_are_and_what_this_covers: {
        title: 'Who we are and what this covers',
        seo_title: 'Who we are and what this covers?',
        content: [
          'w SpA ("wicadu", "we", "us", "our") provides access to the wicadu software-as-a-service platform. We license access; we do not sell our software or intellectual property',
          'This Refund Policy explains when and how we issue refunds for paid plans purchased on wicadu.com or related subdomains',
          'This Policy is incorporated into our Terms and Conditions and governed by the laws of Chile, with exclusive venue in Santiago de Chile',
        ],
      },
      how_billing_works_saas_license_not_sale: {
        title: 'How billing works (SaaS license, not sale)',
        seo_title: 'How billing works (SaaS license, not sale)?',
        content: [
          'Your purchase is a pre-paid, time-limited right to access and use the wicadu SaaS while your plan is active. We may offer monthly or annual billing. Taxes, regulatory fees, and currency conversion may apply',
          'We use third-party providers to operate and bill our services. Payments may be processed by Paddle (our Merchant of Record) or by Transbank for customers paying in UF/CLP in Chile. Your payment receipts may show Paddle or Transbank as the charging entity, as applicable',
        ],
      },
      fourteen_day_money_back_policy: {
        title: '14-day money-back policy',
        seo_title: '14-day money-back policy',
        content: [
          'You may request a refund within 14 calendar days of the charge date of a new subscription or a renewal',
          'To be eligible: Cancel your plan in your wicadu account within the 14-day window; and Submit a refund request to the wicadu Help Center within the same 14-day window, including your reason',
          'After 14 days, fees are non-refundable except where required by law or as expressly stated below',
        ],
      },
      what_s_not_refundable: {
        title: 'What\'s not refundable',
        seo_title: 'What\'s not refundable?',
        content: [
          'After the 14-day window: any remaining time in the billing period is not refundable',
          'Usage-based or metered fees, overage charges, one-time setup/professional services, third-party marketplace fees, domain registrations, or taxes and regulatory fees collected on our behalf, to the extent permitted by law',
          'Accounts terminated or suspended for violations of our Terms and Conditions, or for unlawful or IP-infringing content. No refunds will be issued in such cases',
          'Credits, coupons, or promotional amounts have no cash value and are not redeemable for cash',
        ],
      },
      free_trials_and_upgrades_downgrades: {
        title: 'Free trials and upgrades/downgrades',
        seo_title: 'Free trials and upgrades/downgrades',
        content: [
          'If we offer a free trial, the 14-day refund window starts on the first paid charge after trial ends',
          'plan changes: If you upgrade, the new charges are covered by this same 14-day window from each charge. If you downgrade or cancel after 14 days from a charge, you retain access until the end of the paid term without a refund',
        ],
      },
      how_to_request_a_refund: {
        title: 'How to request a refund',
        seo_title: 'How to request a refund?',
        content: [
          'Step 1: Cancel in your wicadu dashboard',
          'Step 2: Open a ticket at the wicadu Help Center within 14 days of the charge. Include your store ID and reason',
          'If your card statement shows "Paddle" you may also initiate via paddle.net using your purchase lookup; Paddle provides first-tier buyer support for refunds as Merchant of Record',
          'If you paid in UF/CLP via Transbank, submit the request to wicadu through the wicadu Help Center; we will coordinate the reversal per Transbank/card-issuer rules',
        ],
      },
      how_refunds_are_issued_and_timelines: {
        title: 'How refunds are issued and timelines',
        seo_title: 'How refunds are issued and timelines?',
        content: [
          'Method: Refunds are issued to the original payment method. We do not issue check or wire refunds',
          'Timelines: Paddle-processed card refunds typically appear 3-5 business days after approval; some methods have longer windows or processor limits (e.g., cards often limited to ~120 days; PayPal ~179 days); and Transbank/UF-CLP reversals follow card-issuer and banking timelines; availability on your statement is controlled by your bank/issuer. Processing times can vary and may extend to the next statement cycle depending on the issuer\'s policies',
          'Currency: If you paid in a currency different from your card\'s currency, the refund amount may differ due to exchange rates, bank fees, or currency conversion spread at the time your issuer posts the refund. wicadu is not responsible for such differences',
        ],
      },
      chargebacks: {
        title: 'Chargebacks',
        seo_title: 'Chargebacks',
        content: [
          'If you initiate a chargeback instead of working with us under this Policy, we may suspend or limit your account during the investigation and respond to the dispute with evidence. Using the refund process above generally leads to faster resolution',
        ],
      },
      exceptions_we_may_grant: {
        title: 'Exceptions we may grant',
        seo_title: 'Exceptions we may grant',
        content: [
          'Although refunds are generally limited to the 14-day window, we may consider exceptions where required by applicable consumer laws, billing system errors, or documented service-availability incidents. Any exception is at our discretion and does not waive our standard policy',
        ],
      },
      third_party_services_and_data_hosting: {
        title: 'Third-party services and data hosting',
        seo_title: 'Third-party services and data hosting',
        content: [
          'By using wicadu, you acknowledge that we rely on third parties (e.g., Auth0/Okta for identity, Cloudflare for security/CDN, AWS/Azure for hosting, Paddle and Transbank for payments). Your data will be processed by these providers as described in our Privacy Policy. This Refund Policy addresses payments and refunds only; data practices are covered in our Privacy Policy',
          'Important: Paddle and Transbank referenced in this Refund Policy are used only to collect fees owed to wicadu for your subscription. They are not used to collect payments from your store\'s end customers unless you independently set them up for your own commerce flows outside of wicadu\'s subscription to us'
        ],
      },
      store_payments_and_refunds_merchants_end_customers: {
        title: 'Store payments and refunds (Merchants - End customers)',
        seo_title: 'Store payments and refunds (Merchants - End customers)',
        content: [
          'Payments in your store: wicadu enables you (the Customer/Merchant) to connect your own payment providers and gateways to charge your end customers for purchases in your store. Examples include card processors, wallets, local payment methods, or other gateways you choose to integrate',
          'No funds flow through wicadu for your store\'s sales: For transactions between you and your end customers, wicadu does not act as seller, merchant of record, payment processor, or payment facilitator; we do not receive, hold, or settle funds from your end customers. Those transactions occur directly between your end customers, you, and your chosen payment provider(s)',
          'Your refund policy for your end customers: You must publish and honor your own refund/cancellation policy for sales in your store and handle all related requests, returns, chargebacks, reversals, and compliance obligations with your payment provider(s) and under applicable law. Do not direct your end customers to wicadu for refunds related to purchases from your store',
          'Our Refund Policy applies only to your subscription with wicadu: The 14-day money-back terms in this document apply solely to fees you pay to wicadu for access to the SaaS. They do not apply to any payments made by your end customers to you in your store',
        ],
      },
      marketing_communications: {
        title: 'Marketing communications',
        seo_title: 'Marketing communications',
        content: [
          'Your marketing preferences are managed under our Privacy Policy. A refund or cancellation does not automatically change your marketing preferences; you can unsubscribe at any time via provided mechanisms',
        ],
      },
      governing_law_venue_and_brand_notice: {
        title: 'Governing law, venue, and brand notice',
        seo_title: 'Governing law, venue, and brand notice',
        content: [
          'This Refund Policy and any dispute related to it or to the wicadu SaaS are governed by the laws of Chile. Any claim must be brought exclusively in the courts of Santiago de Chile. "wicadu" is a registered brand in Chile',
        ],
      },
      changes_to_this_refund_policy: {
        title: 'Changes to this Refund Policy',
        seo_title: 'Changes to this Refund Policy',
        content: [
          'We may update this Policy from time to time. If changes are material, we will provide notice (for example, by email or in-product notice). The "Last updated" date will reflect the current version',
        ],
      },
      date: {
        content: [
          'Effective date: August 21, 2025',
          'Last updated: August 21, 2025'
        ]
      },
    },
  },
  fr: {
    seo_title: 'Politique de remboursement',
    seo_description:
      "Consultez la politique de remboursement de wicadu pour comprendre les conditions et procédures applicables aux annulations et remboursements d'abonnement.",
    seo_keywords:
      "wicadu, politique de remboursement, remboursement d'abonnement, annulation d'abonnement, conditions de remboursement, politique d'annulation, remboursements en ligne",
    breadcrumbs: {
      home: 'Accueil',
      legal: 'Politiques et conformité',
      refund_policy: 'Politique de remboursement',
    },
    page_id: PagesId.LegalRefundPolicy,
    article: {
      title: 'Politique de remboursement',
      description: 'Veuillez consulter la version anglaise',
    },
  },
  pt: {},
}


export default globalTranslations
